import DiscoverNewTile from "../DiscoverNewTile";


/*
 * sample object
    {
        "tileId": 81,
        "imageUrl": "https://bswcdndesign-prod.bswhealth.com/content/img/features-non-bswh.svg",
        "tags": "non-BSWH DiscoverSomethingNew",
        "sortOrder": 1,
        "name": "Connect your non-BSWH health info",
        "featureName": "DiscoverSomethingNew",
        "title": "Connect your non-BSWH health info",
        "actionType": "LINK",
        "actionLink": "_test_tile",
        "requiresAuthentication": false,
        "allMemberships": true,
        "specificMemberships": "",
        "isDismissed": false
    }
*/

const useTiles = (props) => {
    
    let tiles = props.tiles.filter(tile => { 
            if (tile.tags.indexOf('video-visit') !== -1) {
                const { currentUser } = props;
                
                return currentUser?.pastAppointments?.lastVideoVisitDate ? false : true;
            } else if (tile.tags.indexOf('in-home-vaccine') !== -1) {
                const enableInHomeFeature = window.serverData.data.enableInHomeFeature;
                const { isActiveFeature_InHomeVaccine, isActiveFeatureAnyone_InHomeVaccine } = props.memberships;
                return enableInHomeFeature && (isActiveFeature_InHomeVaccine || !props.isProxyUser && isActiveFeatureAnyone_InHomeVaccine);
            }
            return true;
        }
    );//.sort((a, b) => { return a.tileId - b.tileId; });
    //tiles.forEach((tile, idx) => {
    //    if (tile.tags.indexOf('video-visit')!==-1) {
    //        tile.show = true;
    //    }
    //    tile.isDismissed = false;
    //});
    
    return tiles;
};

export default useTiles;



/*
 * Orginal objects used.
    const defaultProps = {
        //id:0,
        //className:"",
        //onArrowClick: () => { console.info(`DiscoverNewTile default arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile default X click`); },
        //label: "DEFAULT",
        //href:"",
        target:"",
        //image:"https://bswcdndesign-prod.bswhealth.com/content/img/features-in-home-vax.svg",
        //oridnal:0,
        //show: true,
        //dismissed: false,
        //borderStyle:"flat",
        //history:props?.history,
        //location:props?.location,
       //match:props?.match
    }
    const connectHealthInfoProps = {
        id: 1,
        className: "",
        onArrowClick: () => { console.info(`DiscoverNewTile connectHealthInfoProps arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile connectHealthInfoProps X click`); },
        label: "Connect your non-BSWH health info",
        href: "/communitymanage",
        target: "",
        image: "https://bswcdndesign-prod.bswhealth.com/content/img/features-non-bswh.svg",
        oridnal: 1,
        show: true,
        dismissed: false,
        borderStyle: "flat",
        history: props?.history,
        location: props?.location,
        match: props?.match
    }
    const scheduleInHomeVaccineProps = {
        id: 2,
        className: "",
        onArrowClick: () => { console.info(`DiscoverNewTile scheduleInHomeVaccineProps arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile scheduleInHomeVaccineProps X click`); },
        label: "Schedule in-home vaccines",
        href: "/inhomevaccine",
        target: "",
        image: "https://bswcdndesign-prod.bswhealth.com/content/img/features-in-home-vax.svg",
        oridnal: 2,
        show: true,
        dismissed: false,
        borderStyle: "flat",
        history: props?.history,
        location: props?.location,
        match: props?.match
    }
    const favoriteDoctorsProps = {
        id: 3,
        className: "",
        onArrowClick: () => { console.info(`DiscoverNewTile favoriteDoctorsProps arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile favoriteDoctorsProps X click`); },
        label: "Set up your favorite doctors",
        href: "/favorites",
        target: "",
        image: "https://bswcdndesign-prod.bswhealth.com/content/img/features-fave-doc.svg",
        oridnal: 3,
        show: false,
        dismissed: false,
        borderStyle: "flat",
        history: props?.history,
        location: props?.location,
        match: props?.match
    }
    const healthTipsProps = {
        id: 4,
        className: "",
        onArrowClick: () => { console.info(`DiscoverNewTile healthTipsProps arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile healthTipsProps X click`); },
        label: "Sign up for inspiring health tips",
        href: "/healthtips",
        target: "",
        image: "https://bswcdndesign-prod.bswhealth.com/content/img/features-scrub-in.svg",
        oridnal: 4,
        show: false,
        dismissed: false,
        borderStyle: "flat",
        history: props?.history,
        location: props?.location,
        match: props?.match
    }
    const videoVisitProps = {
        id: 5,
        className: "",
        onArrowClick: () => { console.info(`DiscoverNewTile videoVisitProps arrow click`); },
        //onXClick: () => { console.info(`DiscoverNewTile videoVisitProps X click`);},
        label: "Try a video visit",
        href: "/videovisitscheduledfor",
        target: "",
        image: "https://bswcdndesign-prod.bswhealth.com/content/img/features-video-visit.svg",
        oridnal: 5,
        show: false,
        dismissed: false,
        borderStyle: "flat",
        history: props?.history,
        location: props?.location,
        match: props?.match
    }
    */